module.exports = __webpack_public_path__ + "img/section4.adc93398.png";